import * as Redux from 'redux';
import { 
  SAVE_TOKEN_LAST_USED_TIME, 
  DEFAULT_TOKEN_LAST_USED_TIME, 
  TOKEN_EXPIRED, 
  TOKEN_RENEW,
  initialIdleState
} from './Constants';
import { ReduxAction } from '../app/app.types';
import { REVERT_TO_INITIAL_STATE } from '../app/app.const';
import { IdleState, IdleActionTypes } from './Types';

const idleReducer: Redux.Reducer<IdleState> = (
  idleState: IdleState = initialIdleState,
  action: ReduxAction<IdleActionTypes, {}>
): IdleState => {
  switch (action.type) {
    case SAVE_TOKEN_LAST_USED_TIME:
      return { ...idleState,
        tokenLastUsedTime: new Date().getTime(),
      };
    case TOKEN_EXPIRED:
      return { ...idleState,
        expired: true
      };
    case TOKEN_RENEW:
     return { ...idleState,
       expired: false
     };
    case REVERT_TO_INITIAL_STATE:
      return {
        tokenLastUsedTime: DEFAULT_TOKEN_LAST_USED_TIME,
        expired: false
      };
    default:
      return idleState;
  }
};

export default idleReducer;


// WEBPACK FOOTER //
// ./src/idle/Reducer.tsx